import { render, staticRenderFns } from "./LicenseBorrowingAndReturning.vue?vue&type=template&id=3460e280&"
import script from "./LicenseBorrowingAndReturning.vue?vue&type=script&lang=js&"
export * from "./LicenseBorrowingAndReturning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports